namespace $ {

	/** Signed, short-lived request; never send the private auth key. */
	export class $shm_hitalama_map_access_request extends $mol_object {

		static body( map: string, time: number ) {
			return `hitalama-map-rights:v1\n${ map }\n${ time }`
		}

		@ $mol_mem_key
		static signed( [ auth, map, time ]: readonly [ $giper_baza_auth, string, number ] ) {
			const data = this.$.$mol_wire_sync( this.$ ).$mol_charset_encode( this.body( map, time ) )
			const sign = this.$.$mol_wire_sync( auth.signer() ).sign( data )
			return JSON.stringify([ 1, map, time, auth.pass().toString(), this.$.$mol_base64_url_encode( sign ) ])
		}

		@ $mol_mem_key
		static parse( raw: string ) {
			if( raw.length > 2048 ) return null
			return this.$.$mol_error_fence( ()=> {
				const value = JSON.parse( raw ) as unknown
				if( !Array.isArray( value ) || value.length !== 5 ) return null
				const [ version, map, time, pub, signature ] = value
				if( version !== 1 || typeof map !== 'string' ) return null
				const link = this.$.$giper_baza_link.check( map )
				if( !link?.lord().str || link.land().str !== map || link.lord().str.length !== 17 ) return null
				if( !Number.isSafeInteger( time ) || time <= 0 ) return null
				if( typeof pub !== 'string' || !/^[a-zA-Z0-9_-]{86}$/.test( pub ) ) return null
				if( typeof signature !== 'string' || !/^[a-zA-Z0-9_-]{86}$/.test( signature ) ) return null
				const pass = this.$.$giper_baza_auth_pass.from( pub )
				if( pass.uint8( 0 ) !== 0xFF ) return null
				return { link, time, pass,
					body: this.$.$mol_charset_encode( this.body( map, time ) ),
					sign: this.$.$mol_base64_url_decode( signature ),
				}
			}, ()=> null )
		}

		@ $mol_action
		static verify( raw: string, now: number ) {
			const parsed = this.parse( raw )
			if( !parsed || Math.abs( now - parsed.time ) > 5 * 60_000 ) return null
			const valid = this.$.$mol_wire_sync( parsed.pass.auditor() ).verify( parsed.body, parsed.sign )
			return valid ? parsed : null
		}

	}

}
